import Body from './body';
import Button from './button';
import CloseButton from './close-button';
import Footer from './footer';
import Header from './header';
import ModalInternal from './modal-internal';
var ModalNamespace = Object.assign(ModalInternal, {
    Body: Body,
    Button: Button,
    CloseButton: CloseButton,
    Footer: Footer,
    Header: Header,
});
export default ModalNamespace;
